import { registerUrlConverter } from './location_url';
import Integrations from 'models/location/integrations';
import LookupApi from 'models/location/integrations/lookup_api';
import WebhooksAdmin from 'models/location/integrations/webhooks_admin';

import ClearLookupApi from 'actions/integrations/clear_lookup_api';
import CloseWebhooks from 'actions/integrations/webhooks/close_webhooks';
import OpenIntegrations from 'actions/integrations/open_integrations';
import OpenLookupApi from 'actions/integrations/open_lookup_api';
import OpenWebhooks from 'actions/integrations/webhooks/open_webhooks';

import StaticUrlConverter from './url_converters/static_url_converter';

registerUrlConverter(Integrations, StaticUrlConverter.create('/integrations'));
registerUrlConverter(LookupApi, StaticUrlConverter.create('/integrations/lookup-api'));
registerUrlConverter(WebhooksAdmin, StaticUrlConverter.create('/integrations/webhooks'));

export default function(router, { runnerContext }) {
  let externalCustomerLookupStatusStore = runnerContext.stores.externalCustomerLookupStatus;
  let hasConnector = externalCustomerLookupStatusStore && externalCustomerLookupStatusStore.get().hasConnector;

  return {
    '/': {
      after() {},

      '/?$': {
        on() {
          if (!hasConnector) {
            runnerContext.executeAction(OpenIntegrations);
          }
        },
      },

      '/lookup-api': {
        on() {
          if (!hasConnector) {
            runnerContext.executeAction(OpenLookupApi);
          }
        },
        after() {
          if (!hasConnector) {
            runnerContext.executeAction(ClearLookupApi);
          }
        },
      },

      '/webhooks': {
        on() {
          runnerContext.executeAction(OpenWebhooks);
        },
        after() {
          runnerContext.executeAction(CloseWebhooks);
        },
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/integrations_routes.js